import React, { useEffect } from 'react';
import { Form, Button, DatePicker, InputNumber } from 'antd';
import { formatDate, getDisabledDates } from 'utils';
import { requiredRule } from 'utils/forms/validationRules';
import { CONTENT_SPAN, LABEL_SPAN } from 'constants/table';
import dayjs from 'dayjs';

function SalaryChangeForm({ initialValues, disableDate, onSubmit, children }) {
  const [form] = Form.useForm();

  useEffect(() => {
    if (initialValues) {
      const { worker_id, begin_date, amount } = initialValues;

      form.setFieldsValue({
        worker_id,
        begin_date: dayjs(begin_date),
        amount,
      });
    }
  }, [initialValues]);

  const handleSubmit = async (values) => {
    const payload = {
      ...values,
      begin_date: formatDate(values?.begin_date, 'YYYY-MM-DD'),
    };

    const isSubmitted = await onSubmit(payload);

    if (isSubmitted) {
      form.resetFields();
    }
  };

  return (
    <Form
      form={form}
      onFinish={handleSubmit}
      layout="horizontal"
      labelCol={{
        span: LABEL_SPAN,
      }}
      wrapperCol={{ span: CONTENT_SPAN }}
      labelAlign="right"
    >
      {children}

      <Form.Item name="begin_date" label="Дата начала" rules={[requiredRule]}>
        <DatePicker
          format="DD.MM.YYYY"
          allowClear
          disabledDate={getDisabledDates(disableDate)}
          style={{ width: '100%' }}
        />
      </Form.Item>

      <Form.Item
        name="amount"
        label="Новый размер заработной платы"
        rules={[
          requiredRule,
          {
            validator: (_, value) => {
              if (value < 60000 || value === null) {
                return Promise.reject(false);
              }

              return Promise.resolve(true);
            },
            message: 'Нужно ввести мининум 60000',
          },
        ]}
      >
        <InputNumber
          addonAfter="KZT"
          controls={false}
          formatter={(value) =>
            `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ' ')
          }
          placeholder="Введите размер заработной платы"
          style={{ width: '100%' }}
        />
      </Form.Item>

      <Form.Item wrapperCol={{ offset: CONTENT_SPAN }}>
        <Button type="primary" htmlType="submit">
          Сохранить
        </Button>
      </Form.Item>
    </Form>
  );
}

export { SalaryChangeForm };
